import { get, getRawValue } from '../../utils/get';
import { getRawImageObject } from '../../adapters/get-raw-image-object';
import { getBasicVideosObject } from '../../adapters/get-basic-videos-object';
import { SD_STATUS } from '../../consts';
import { getItemsSdStatus } from '../utils';
var PREFIX = 'media/';
var getVideoName = function (projectItem) {
    var videoTitle = get(projectItem, 'title');
    if (videoTitle) {
        return videoTitle;
    }
    else {
        return get(projectItem, 'video.videoInfo.filename');
    }
};
var getVideoThumbnailUrl = function (projectItem) {
    var posters = getRawValue(projectItem, 'video.videoInfo.posters');
    var urls = [];
    posters.forEach(function (item) {
        var url = get(item, 'url');
        if (url.startsWith(PREFIX)) {
            url = url.slice(PREFIX.length);
        }
        urls.push(url);
    });
    return urls.length > 0 ? urls : '';
};
var getVideoStructuredData = function (videosData) {
    if (videosData.length === 0) {
        return '';
    }
    else if (videosData.length === 1) {
        var videosObject = getBasicVideosObject(videosData, {
            includeContext: false,
            positioning: false,
        }).videos;
        return videosObject[0];
    }
    else {
        var itemListArr = getBasicVideosObject(videosData, {
            includeContext: false,
            positioning: true,
        }).videos;
        return {
            '@type': 'ItemList',
            itemListElement: itemListArr,
        };
    }
};
export var getStructuredData = function (IDs, item, projectItems) {
    var _a;
    if (!IDs) {
        return {};
    }
    var imagesData = [];
    var videosData = [];
    projectItems === null || projectItems === void 0 ? void 0 : projectItems.forEach(function (projectItem) {
        var type = get(projectItem, 'type');
        switch (type) {
            case 'IMAGE':
                imagesData.push({
                    url: get(projectItem, 'image.imageInfo.url'),
                    width: get(projectItem, 'image.imageInfo.width'),
                    height: get(projectItem, 'image.imageInfo.height'),
                    name: get(projectItem, 'image.imageInfo.altText'),
                });
                break;
            case 'VIDEO':
                videosData.push({
                    name: getVideoName(projectItem),
                    thumbnailUrl: getVideoThumbnailUrl(projectItem),
                    uploadDate: get(projectItem, 'createdDate'),
                    contentUrl: get(projectItem, 'video.videoInfo.url'),
                    description: get(projectItem, 'description'),
                });
                break;
            default:
                break;
        }
    });
    var coverImage = getRawValue(item, 'project.coverImage');
    if (coverImage) {
        imagesData.push({
            url: get(coverImage, 'imageInfo.url'),
            width: get(coverImage, 'imageInfo.width'),
            height: get(coverImage, 'imageInfo.height'),
            name: get(coverImage, 'imageInfo.altText'),
        });
    }
    var _b = getRawImageObject('images', imagesData).images, images = _b === void 0 ? '' : _b;
    var videos = getVideoStructuredData(videosData.filter(function (video) { return (video === null || video === void 0 ? void 0 : video.name) && (video === null || video === void 0 ? void 0 : video.thumbnailUrl) && (video === null || video === void 0 ? void 0 : video.uploadDate); }));
    var imagesSdStatus = getItemsSdStatus(imagesData, images);
    var videosSdStatus = getItemsSdStatus(videosData, videos);
    return _a = {},
        _a[IDs.SD_JSON_IMAGES] = images,
        _a[IDs.SD_JSON_VIDEOS] = videos,
        _a[IDs.IMAGES_SD_STATUS] = imagesSdStatus,
        _a[IDs.VIDEOS_SD_STATUS] = videosSdStatus,
        _a[IDs.DISABLE_IMAGES_SCHEMA] = imagesSdStatus !== SD_STATUS.ENABLED,
        _a[IDs.DISABLE_VIDEOS_SCHEMA] = videosSdStatus !== SD_STATUS.ENABLED,
        _a;
};
